import { Workstream, Synergy, IntegrationMilestone } from '../types/integration';

// Sample Workstreams
export const sampleWorkstreams: Workstream[] = [
  {
    id: 'w1',
    dealId: 'deal-1',
    type: 'it',
    name: 'IT Systems Integration',
    description: 'Integration of core IT systems and infrastructure',
    status: 'in_progress',
    progress: 35,
    startDate: '2024-03-01',
    endDate: '2024-06-30',
    owner: 'Michael Chen',
    tasks: []
  },
  {
    id: 'w2',
    dealId: 'deal-1',
    type: 'hr',
    name: 'HR Integration',
    description: 'Employee onboarding and system consolidation',
    status: 'not_started',
    progress: 0,
    startDate: '2024-04-01',
    endDate: '2024-07-31',
    owner: 'Emily Rodriguez',
    tasks: []
  }
];

// Sample Synergies
export const sampleSynergies: Synergy[] = [
  {
    id: 's1',
    dealId: 'deal-1',
    type: 'cost',
    description: 'IT Infrastructure Consolidation',
    targetValue: 2000000,
    actualValue: 500000,
    timeline: '2024-Q2',
    status: 'in_progress',
    owner: 'Michael Chen'
  },
  {
    id: 's2',
    dealId: 'deal-1',
    type: 'revenue',
    description: 'Cross-selling Opportunities',
    targetValue: 5000000,
    actualValue: 1000000,
    timeline: '2024-Q3',
    status: 'in_progress',
    owner: 'Sarah Johnson'
  }
];

// Sample Milestones
export const sampleMilestones: IntegrationMilestone[] = [
  {
    id: 'm1',
    dealId: 'deal-1',
    title: 'Day 1 Readiness',
    description: 'Complete all Day 1 critical activities',
    date: '2024-06-30',
    status: 'upcoming',
    workstreamId: 'w1'
  },
  {
    id: 'm2',
    dealId: 'deal-1',
    title: 'Systems Integration Complete',
    description: 'All core systems integrated and tested',
    date: '2024-09-30',
    status: 'upcoming',
    workstreamId: 'w1'
  }
];